import authApi from 'root/src/shared/util/authApi'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { VERIFY_NEW_EMAIL_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import getDomainRoute from 'root/src/client/util/getDomainRoute'

export default ({ email, token = undefined }) => async () => {
	const { error } = await authApi.changeEmail({
		email,
		redirectUrl: getDomainRoute(),
		token,
	})

	if (error) {
		throw error
	}

	return pushRouteClient({ routeId: VERIFY_NEW_EMAIL_ROUTE_ID })
}
